<template>
  <div class="step-section">
    <h2>Step Three: Pull data</h2>
    <p>
      To generate blood forms, <b>Weekend</b> needs to know your patients' details.
    </p>
    <p>
      <b>Weekend</b> will scrape this information from <b>[redacted hospital system name]</b>.
    </p>
    <p>
      For <b>Weekend</b> to do this correctly, you must have an Admission List widget for your team on your <b>[redacted hospital system name]</b> homepage.
    </p>

    <p>
      You also must have both <b>Weekend</b> and <b>[redacted hospital system name]</b> open in any browser <b style="color: red;">other than Internet Explorer</b>.
    </p>

    <p>
      <b>Step Three a)</b>
    </p>
    <p>
      Enter your team's <i>"short name"</i> from the Admission List widget. Examples include <i>"SUR4"</i>, <i>"MED2"</i>, <i>"REN1"</i> et cetera.
    </p>
    <p>
      <input type="text" v-model="teamName" >
    </p>

    <p>
      <b>Step Three b)</b>
    </p>
    <p>
      Click <button @click="saveDataScript">Save to Clipboard</button> to save your data scraping script.
    </p>

    <p>
      <b>Step Three c)</b>
    </p>
    <p>
      Return to the <b>[redacted hospital system name]</b> home page and right click anywhere. Click <i>Inspect</i> and then click the <i>Console</i> tab. Paste the data scraping script here, and hit <i>Enter</i>. This will save your patient information to the clipboard.
    </p>

    <p>
      <b>Step Three d)</b>
    </p>
    <p>
      Paste your patient information into the text field below:
    </p>
    <p style="width: 100%;">
      <textarea></textarea>
    </p>

  </div>
</template>

<script>

export default {
  name: 'StepThree',
  components: {},
  data() {
    return {
      teamName: null
  	}
  },
  methods: {
    async saveDataScript(){
      if (this.teamName != null) {
        await navigator.clipboard.writeText("This example version does not contain the actual scraping script. Pasting any text into the input field will yield the same result.");
        alert('Saved data script to clipboard using team name "'+this.teamName+'"')
      } else {
        alert('Please enter a valid short team name.')
      }
    }
  }
}
</script>

<style>
  textarea {
    resize: none;
    width: 100%;
    height: 120px;
  }
</style>
